export const REPORT_TYPE = {
  BPM: "bpm",
  STEPS: "step",
  GNSS: "gnss",
  ALARM: "alarm",
};

export const REPORT_TITLE = {
  BPM: "Heart Rate BPM Report",
  STEPS: "Steps Report",
  GNSS: "GNSS Report",
  ALARM: "Message List Report",
  SEND_MESSAGE: "Send Message",
  DEVICE_LIST: "Demo device list",
};

export const NO_DATA = {
  MESSAGE: "No data",
};

export const APP_TITLE = {
  TITLE: "mSafety DemoApp",
  ERROR_TITLE: "DemoApp WebPage",
};

export const RESPONSE_ERROR_MESSAGE = {
  400: "The request cannot be fulfilled due to bad syntax.",
  401: "Unauthorized. Please login to continue.",
  403: "You don’t have permission to access this resource.",
  404: "Page you are trying to open does not exist. You may have mistyped the address, or the page has been moved to another URL.",
  500: "Something bad just happened. Our servers could not handle your request. Try refreshing the page.",
  503: "All of our servers are busy. We cannot handle your request right now, please wait for a couple of minutes and refresh the page.",
  DEFAULT: "Sorry, an unexpected error has occurred.",
};

export const VERIFY_ERROR_MESSAGE = {
  VERIFY_USER_NAME_MESSAGE: "You must provide a username or email to log in.",
  VERIFY_PW_MESSAGE: "You must provide a password to log in.",
  VERIFY_SIGNIN_MESSAGE: "Invalid login attempt.",
};

export const SHEET_TYPE_ID = {
  BPM: "_65082a95-5ca5-471e-a060-da9a5c6be754",
  STEPS: "_bd32927d-ffb6-45fc-9332-8d73c6178895",
  GNSS: "_b9af6abf-ee07-4e98-88ad-754c9674b304",
  ALARM: "_25e04661-00f3-41cf-9d6b-f2907afe3687",
};

export const INPUT_TYPE_NAME = {
  TITLE: "title",
};

export const CONSTANT_SET = {
  LETTER_WIDTH: 14,
  CHAR_WIDTH: 21,
  MAX_TITLE_CHARACTER: 6,
  MAX_TITLE_LETTER: 9,
  MAX_MESSAGE_CHARACTER: 33,
  MAX_MESSAGE_letter: 50,
  MAX_INPUT_WIDTH: 126,
  MAX_MESSAGE_INPUT_WIDTH: 1050,
  MAX_MESSAGE_PROPORTION: 0.7,
  MIN_MESSAGE_PROPORTION: 0.3,
};

export const ALERT_TYPE = {
  ALARM: "manual",
  FALLING: "fall",
  STILL: "still", 
  CHARGING: "charging",
  CANCELLED: "cancelled"
}

export const MODE_TYPE = {
  ASSIGNED: "assigned"
}

export const BATTERY_PERCENTAGE = {
  LOW: 40,
  MEDIUM: 60,
  HIGH: 90,
}

export const SIGNAL_STRENGTH = {
  LOW: 30,
  HIGH: 60,
}
